import { createContext, useContext } from 'react';

/// O que o aviso SIGNIFICA, não a cor que ele tem — mesma escolha da pílula de situação.
export type SnackbarTone = 'positive' | 'danger' | 'info';

/// Um botão no próprio aviso, como o "Desfazer" depois de arrastar um agendamento.
export interface SnackbarAction {
  label: string;
  onAction: () => void;
}

export interface Snackbar {
  show: (text: string, tone?: SnackbarTone, action?: SnackbarAction) => void;
  /// Deu certo. Some sozinho — com ação, espera um pouco mais, para dar tempo de apertá-la.
  success: (text: string, action?: SnackbarAction) => void;
  /// Não deu. Fica até alguém fechar.
  failure: (text: string) => void;
}

export const SnackbarContext = createContext<Snackbar | null>(null);

/// Quanta altura a pilha ocupa no canto inferior, em pixels. Quem também mora nesse canto lê daqui
/// para sair da frente; sem provider a resposta é zero, e nada se move.
export const SnackbarSpaceContext = createContext(0);

/// Falta o provider, e a tela ficaria muda sem ninguém perceber — que é exatamente o defeito que o
/// snackbar veio corrigir. Por isso quebra alto, e não em silêncio.
export function useSnackbar(): Snackbar {
  const snackbar = useContext(SnackbarContext);
  if (!snackbar) throw new Error('useSnackbar exige um <SnackbarProvider> acima na árvore.');
  return snackbar;
}

export function useSnackbarSpace(): number {
  return useContext(SnackbarSpaceContext);
}
